import { callApi } from '@local_modules/generic/fetch'
import { fillString } from '@local_modules/generic/string-template.js'

const cachedData = {}

export async function loadData (params) {
  if (!params.monthISO) return

  const apiUrl = '/api/data-review/check-vs-xero-pnl/:accountingOrganisationId?monthISO=:monthISO&numberMonths=:numberMonths&queryTrackings=:queryTrackings'
  const callUrl = fillString(apiUrl, {
    accountingOrganisationId: params.accountingOrganisationId,
    monthISO: params.monthISO,
    numberMonths: params.numberMonths, // Mostly used with '1' to load 1 month at a time
    queryTrackings: params.queryTrackings
  })

  if (cachedData[callUrl]) {
    return cachedData[callUrl]
  }

  const apiResponse = await callApi(callUrl)
  console.log('apiResponse', apiResponse)

  const storeData = {
    data: apiResponse,
    monthISO: params.monthISO,
    numberMonths: params.numberMonths,
    queryTrackings: params.queryTrackings,
    rows: prepareData(apiResponse)
  }

  cachedData[callUrl] = storeData

  return storeData
}

function prepareData (apiResponse) {
  const rows = []

  const monthData = apiResponse.comparisonResults?.[0] || {}
  const coaByDbId = monthData.db?.entityCoa?.coaByDbId || {}

  const multipleToCreditPositive = -1

  monthData.reconciled?.combinedEntries?.forEach(reconcilationEntry => {
    const row = {
      key: reconcilationEntry.reconciliationKey,
      isMatching: reconcilationEntry.isMatching,
      isFx: reconcilationEntry.isKnownIssue || false,
      issue: reconcilationEntry.issue,
      isKnownIssue: reconcilationEntry.isKnownIssue,
      accounting_chart_of_account_id: reconcilationEntry.accounting_chart_of_account_id,
      accountName: coaByDbId[reconcilationEntry.accounting_chart_of_account_id]?.name || '',
      xeroAccountId: reconcilationEntry._dbValue?._coa?.xero_id || reconcilationEntry?._xeroValue?.xeroAccountId || '',
      amountXero: Number.isFinite(reconcilationEntry.amountXero) ? reconcilationEntry.amountXero * multipleToCreditPositive : null,
      amountDb: Number.isFinite(reconcilationEntry.amountDb) ? reconcilationEntry.amountDb * multipleToCreditPositive : null,
      delta: reconcilationEntry.delta || null,
      tracking1: reconcilationEntry.t1 || null,
      tracking2: reconcilationEntry.t2 || null,
      data: reconcilationEntry
    }

    rows.push(row)
  })

  return rows
}
